"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPagePropGetter = void 0;
const get_1 = __importDefault(require("lodash/get"));
function createPagePropGetter(propKey, defaultValue) {
    return function pagePropsGetter(pageProps) {
        return (0, get_1.default)(pageProps, ['props', propKey], (0, get_1.default)(pageProps, propKey, defaultValue));
    };
}
exports.createPagePropGetter = createPagePropGetter;
//# sourceMappingURL=serverSidePropsPipe.js.map